import { FC } from 'react';
import { useMedia } from 'react-use';

import { minDesktopWidth } from '../../../../../../shared/widths';

import styles from './styles.module.scss';

import { ReactComponent as MetroCountingBg } from '../../../../../../assets/images/metro/MetroCountingBg.svg';
import { ReactComponent as MetroCountingBgTablet } from '../../../../../../assets/images/metro/MetroCountingBgTablet.svg';
import { ReactComponent as RightAnswerCell } from '../../../../../../assets/images/metro/RightAnswerCell.svg';
import { ReactComponent as Cursor } from '../../../../../../assets/images/metro/Cursor.svg';

export const PeopleCountingScene: FC = () => {
  const isDesktop = useMedia(`(min-width: ${minDesktopWidth}px)`);
  return (
    <div className={styles.container}>
      {isDesktop ? <MetroCountingBg /> : <MetroCountingBgTablet />}
      <RightAnswerCell className={styles.rightAnswer} />
      <Cursor className={styles.cursor} />
    </div>
  );
};
